export default "__VITE_ASSET__lQfknUJm__"